import api from './api'

const install = vx => {
  if (!vx || install.installed)
    return;
  install.installed = true;
  // 挂载 $axios 到 原型
  vx.prototype.$api = api
}

export default install



// WEBPACK FOOTER //
// ./src/plugins/axios/index.js